import { cn } from '@/lib/utils';
import React from 'react';

interface GlowCardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Glow color — defaults to primary */
  glow?: 'primary' | 'destructive' | 'none';
}

const glowStyles = {
  primary: 'hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5',
  destructive: 'hover:border-destructive/30 hover:shadow-lg hover:shadow-destructive/5',
  none: '',
};

const GlowCard = React.forwardRef<HTMLDivElement, GlowCardProps>(
  ({ className, glow = 'primary', children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-xl border border-border bg-card p-6 transition-all duration-300',
        glowStyles[glow],
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
);
GlowCard.displayName = 'GlowCard';

export { GlowCard };
